var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value.note)?_c('div',{staticClass:"d-flex flex-column"},[_c('span',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.value.note))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }